let messages = [
    {
      id: 1,
      primary: 'Strada Interrota',
      secondary: "La strada per l'accesso al mare sara' interrota tra le 21:00 del 20 Giugno e le 4:00 del 21 Giugno, per urgenti lavori di manutenzione",
      icon: 1,
    },
    {
      id: 2,
      primary: 'Riunione per tutta la comunita',
      secondary: "L'amministrazione intende condividere la situazione del bilancio con tutta la popolazione in una riunione",
      icon: 2,
    }
]

export default messages;